import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formSubmission: '=',
        company: '='
    },
    template: `
        <div class="heading01" ng-if="vm.formSubmission.isTrial">
            <h2></h2>
            <forms-language-switcher form-submission="vm.formSubmission" selected-language="vm.selectedLanguage" />
        </div>
        <div class="loader02" ng-if="!vm.form && !vm.error">{{ 'question.Please wait' | translate }}</div>
        <p ng-if="vm.error" class="alert alert-danger"><span>{{ vm.error }}</span></p>
        <div ng-if="vm.form && !vm.error">
            <div class="quiz">
                <h2>{{ vm.greetingText }}, {{ vm.formSubmission.name }}</h2>
                <p ng-bind-html="vm.introduction"></p>
                <p class="desc"><span class="red">*</span> - {{ 'forms.This question is mandatory' | translate }}</p>
                <div ng-repeat="category in vm.categories">
                   <evaluation-public-evaluation-category ng-if="category.id"
                       form="vm.form"
                       category="category"
                       opened-tab="vm.openedTab"
                       index="$index"
                       counter="vm.counter"
                       categories-count="vm.categoriesCount"
                   />
                   <div class="question" ng-if="!category.id" ng-repeat="question in category.questions">
                       <evaluation-public-evaluation-question-scale
                            form="vm.form"
                            answered-questions="vm.answeredQuestions"
                            question="question"
                            counter="vm.counter[question.id]"
                            ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.SCALE"
                       />
                       <evaluation-public-evaluation-question-free-text
                            form="vm.form"
                            counter="vm.counter[question.id]"
                            answered-questions="vm.answeredQuestions"
                            question="question"
                            ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT"
                       />
                    </div>
                </div>
            </div>
            <ul class="actions01">
                <li class="primary"><button class="btn main" ng-click="vm.submit(false)">{{ vm.getSubmitButtonText() }}</button></li>
                <li class="primary"><a class="btn bordered02" ng-if="!vm.formSubmission.isTrial" ng-click="vm.submit(true)">{{ 'general.Save as draft' | translate }}</a></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $rootScope, $scope, $state, toastr, lodash,
                 ModalService, TokenService, ResponseService, MomentService, FormSubmissionService,
                 FormSubmissionAnswerResource, FormSubmissionResource, ErrorHandlerFactory,
                 FORMS_LANGUAGE_SWITCHER_ENUM, QUESTIONS_TYPE_ENUM, FORMS_SUBMISSION_STATUS_ENUM,
                 EVALUATION_INTRODUCTION_PLACEHOLDER_ENUM) {
        this.$translate = $translate;
        this.$state = $state;
        this.toastr = toastr;
        this.lodash = lodash;
        this.ModalService = ModalService;
        this.TokenService = TokenService;
        this.ResponseService = ResponseService;
        this.MomentService = MomentService;
        this.FormSubmissionAnswerResource = FormSubmissionAnswerResource;
        this.FormSubmissionResource = FormSubmissionResource;
        this.FormSubmissionService = FormSubmissionService;
        this.ErrorHandlerFactory = ErrorHandlerFactory;
        this.FORMS_LANGUAGE_SWITCHER_ENUM = FORMS_LANGUAGE_SWITCHER_ENUM;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.FORMS_SUBMISSION_STATUS_ENUM = FORMS_SUBMISSION_STATUS_ENUM;
        this.EVALUATION_INTRODUCTION_PLACEHOLDER_ENUM = EVALUATION_INTRODUCTION_PLACEHOLDER_ENUM;

        const listener = $rootScope.$on('evaluation:language', (event, data) => {
            this.language = data;
            this.selectedLanguage = this.language;
            this.form = false;

            this.initEvaluation();
        });

        $scope.$on('$destroy', listener);
    }

    $onInit () {
        this.openedTab = 0;
        this.counter = {};
        this.answeredQuestions = 0;

        this.language = this.formSubmission.user ? this.formSubmission.user.coursyLanguage.toLowerCase() : this.$translate.use();

        this.$translate.use(this.language).then(() => this.initEvaluation());
    }

    initEvaluation () {
        this.error = false;

        if (this.formSubmission.isTrial && !this.selectedLanguage) {
            this.selectedLanguage = this.formSubmission.user ? this.formSubmission.user.coursyLanguage : this.TokenService.getActiveLanguage();
        }

        if (this.formSubmission.evaluationGroup && this.MomentService.isPassedTimeStamp(this.formSubmission.evaluationGroup.deadline)) {
            this.error = this.$translate.instant('evaluation.Feedback deadline has passed');
        }
        else if (this.formSubmission.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.FINISHED) {
            this.error = this.$translate.instant('evaluation.You have already submitted feedback for this person');
        }
        else {
            this.introduction = this.getIntroduction();
            this.greetingText = this.getGreetingText();
            if (this.formSubmission.isTrial) {
                this.initIntroductionTranslations();
            }
            this.loadTest();
        }
    }

    getGreetingText () {
        return this.$translate.instant('evaluation.Hello');
    }

    loadTest () {
        if (this.formSubmission.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.NOT_STARTED) {
            // call start to set correct submission start time and status
            this.FormSubmissionResource.start({ guid: this.formSubmission.guid }).$promise.then(() => {});
        }
        this.getQuestions().then(() => {
            this.form = {
                language: this.language,
                guid: this.formSubmission.guid,
                formId: this.formSubmission.formId,
                answers: []
            };
        });
    }

    submit (isDraft) {
        if (this.formSubmission.isTrial) {
            this.$state.go('authorized.forms.forms.form.general', { id: this.formSubmission.formId });
            return;
        }
        this.form.isDraft = isDraft;


        if (isDraft) {
            this.FormSubmissionAnswerResource.batchCreate({ expand: 'form', _lang: this.language }, this.form).$promise
                .then(data => this.handleSuccess(data, isDraft))
                .catch(response => this.handleErrors(response));
        }
        else {
            this.FormSubmissionAnswerResource.batchCreate({ expand: 'form', _lang: this.language, validateOnly: true }, this.form).$promise.then(() => {
                const confirmMessage = this.$translate.instant('evaluation.After submitting the answers you cannot change them. Are you sure you wish to submit the feedback?');
                this.ModalService.confirm(confirmMessage, 'medium').then(() => {
                    this.FormSubmissionAnswerResource.batchCreate({ expand: 'form', _lang: this.language }, this.form).$promise
                        .then(data => this.handleSuccess(data, isDraft))
                        .catch(response => this.handleErrors(response));
                });
            }).catch(response => this.handleErrors(response));
        }
    }

    handleSuccess (data, isDraft) {
        if (isDraft) {
            this.toastr.success(this.$translate.instant('general.Draft saved'));
        }
        this.formSubmission = data;
        if (data.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.FINISHED) {
            this.$state.go('evaluation.evaluation.finished', { guid: this.formSubmission.guid });
        }
        else if (data.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.IN_PROGRESS) {
            this.loadTest();
        }
    }

    handleErrors (response) {
        // just in case try to reload evaluation if response is empty
        if (!response.data) {
            this.loadTest();
            return;
        }
        const errors = this.ErrorHandlerFactory.parseFormErrors(response);
        const uniqueErrors = [];
        this.lodash.forEach(errors, (error) => {
            if (uniqueErrors.indexOf(error) === -1) {
                this.toastr.error(error);
                uniqueErrors.push(error); // filter out duplicate errors
            }
        });

        const parsedErrors = this.ResponseService.parseErrors(response);
        this.lodash.forEach(this.form.answers, (answer, key) => {
            if (this.lodash.has(parsedErrors, `answers.${key}`)) {
                this.lodash.assign(answer, { errors: parsedErrors.answers[key] });
            }
        });
    }

    getQuestions () {
        const params = {
            guid: this.formSubmission.guid,
            pageSize: 0,
            _lang: this.formSubmission.isTrial ? this.selectedLanguage : this.language
        };
        // the answers request has to be part of the returned chain. Otherwise loadTest() replaces vm.form
        // one round trip before vm.categories is refreshed, the questions get rendered against the
        // previous category list and every answer ends up pushed twice into vm.form.answers
        return this.FormSubmissionResource.evaluationQuestions(params).$promise
            .then(categories => this.FormSubmissionService.getAnswers(this.formSubmission)
                .then((answers) => {
                    // create overall question counter and load answers
                    let counter = 1;
                    this.lodash.forEach(categories, (category) => {
                        this.lodash.forEach(category.questions, (question) => {
                            this.counter[question.id] = counter++;
                            const questionTypes = [
                                this.QUESTIONS_TYPE_ENUM.KEYS.RADIO,
                                this.QUESTIONS_TYPE_ENUM.KEYS.SCALE,
                                this.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT
                            ];
                            if (this.lodash.includes(questionTypes, question.type)) {
                                question.submittedAnswer = this.lodash.find(answers, answer => answer.questionId === question.id);
                            }
                            else if (question.type === this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX) {
                                question.submittedAnswers = this.lodash.filter(answers, answer => answer.questionId === question.id);
                            }
                            else if (question.type === this.QUESTIONS_TYPE_ENUM.KEYS.MATRIX) {
                                this.lodash.forEach(question.childQuestions, (childQuestion) => {
                                    childQuestion.submittedAnswer = this.lodash.find(answers, answer => answer.questionId === childQuestion.id);
                                });
                            }
                        });
                    });

                    this.categories = categories;
                    this.categoriesCount = this.categories.length;
                }))
            .catch(response => {
                this.error = this.lodash.get(response, 'data.message')
                    || this.$translate.instant('general.Something went wrong');
            });
    }

    getSubmitButtonText () {
        return this.formSubmission.isTrial ? this.$translate.instant('forms.Back to form') : this.$translate.instant('evaluation.Send questionnaire');
    }

    initIntroductionTranslations () {
        this.FORMS_LANGUAGE_SWITCHER_ENUM.map(language => {
            return this.$translate.instant('evaluation.INTRODUCTION_TEXT', { company: this.company.name }, undefined, language.KEY.toLowerCase());
        });
    }

    getIntroduction () {
        const deadlinePlaceholder = this.EVALUATION_INTRODUCTION_PLACEHOLDER_ENUM.GROUP_DEADLINE;

        // Use the evaluation group from the submission (old code used `this.evaluationGroup`)
        const group = this.formSubmission ? this.formSubmission.evaluationGroup : null;
        if (!group || !group.deadline) {
            return '';
        }

        const deadline = this.MomentService.formatTimeStamp(group.deadline);

        // Resolve languages
        const currentLang = ((this.formSubmission && this.formSubmission.isTrial ? this.selectedLanguage : this.language) || '').toUpperCase();
        const defaultLang = (this.company && this.company.defaultLanguage ? this.company.defaultLanguage : '').toUpperCase();

        // Helper to pick introduction from either an object keyed by language or an array of i18ns
        const pickIntro = (i18ns) => {
            if (!i18ns) return null;

            // New structure: object keyed by lang, e.g. { ET: {...}, EN: {...} }
            if (!Array.isArray(i18ns) && typeof i18ns === 'object') {
                const cur = i18ns[currentLang];
                const def = defaultLang ? i18ns[defaultLang] : null;
                return (cur && cur.introduction) || (def && def.introduction) || null;
            }

            // Legacy structure: array of { language: 'ET', introduction: '...' }
            if (Array.isArray(i18ns)) {
                const byLang = (lang) => this.lodash.find(i18ns, i => (i.language || '').toUpperCase() === lang);
                const cur = currentLang ? byLang(currentLang) : null;
                const def = defaultLang ? byLang(defaultLang) : null;
                return (cur && cur.introduction) || (def && def.introduction) || null;
            }

            return null;
        };

        // 1) Prefer per-evaluation i18ns (new place)
        const evalI18ns =
            (this.formSubmission && this.formSubmission.evaluationGroupI18ns) ||
            (group && group.evaluationGroupI18ns); // just in case some older payloads nest it
        const introFromEvaluation = pickIntro(evalI18ns);

        // 2) Fallback to company i18ns (separate API response)
        const introFromCompany = pickIntro(this.company && this.company.companyI18ns);

        const intro = introFromEvaluation || introFromCompany || '';
        if (!intro) return '';

        // Replace {GROUP_DEADLINE} everywhere
        return this.lodash.replace(intro, new RegExp(deadlinePlaceholder, 'g'), deadline);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/evaluation/index.js